module.exports = __webpack_public_path__ + "img/manet_6.85df5cda.jpg";